export default {
  apiUrl: 'https://ustac-api.armorymaster.com/api/v1'
};
